var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filing"},[_vm._v(" CopyRight@2023广州科密信息技术有限公司-"),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("粤ICP备2023127373号")])])
}]

export { render, staticRenderFns }